import { render } from "./pagination.html?vue&type=template&id=418c5a58&scoped=true&external"
import script from "./pagination.js?vue&type=script&lang=js&external"
export * from "./pagination.js?vue&type=script&lang=js&external"

import "./pagination.scss?vue&type=style&index=0&id=418c5a58&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-418c5a58"],['__file',"src/components/ui/pagination/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "418c5a58"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('418c5a58', __exports__)) {
    api.reload('418c5a58', __exports__)
  }
  
  module.hot.accept("./pagination.html?vue&type=template&id=418c5a58&scoped=true&external", () => {
    api.rerender('418c5a58', render)
  })

}


export default __exports__